<template>
  <div v-if="quantity > 1"
       class="pagination">
    <div class="pagination__main">
      <!--  PREV  -->
      <router-link-modified v-if="quantity > 1 && currentPage !== prevPage"
                   key="prev"
                   :to="prevPageQuery"
                   class="pagination__prev"
      >
        <BaseSvg name="ico-arrow-light"/>
      </router-link-modified>
      <div v-else
           key="prev-disabled"
           class="pagination__prev  _disabled"
      >
        <BaseSvg name="ico-arrow-light"/>
      </div>

      <div class="pagination__col  _left">
        <router-link-modified v-if="quantity > 1 && currentPage > 1"
                     key="1.1"
                     :to="{query: firstPageQuery}"
                     class="pagination__item"
        >
          1
        </router-link-modified>
        <div v-if="currentPage > 3" class="pagination__item  _dots">...</div>
        <router-link-modified v-if="pagesPrev[0] === 1"
                     key="1.2"
                     :to="{query: firstPageQuery}"
                     class="pagination__item"
        >
          1
        </router-link-modified>
        <router-link-modified v-for="current in pagesPrevWithoutOne"
                     :key="current"
                     :to="{query: {...$route.query, page: current}}"
                     class="pagination__item"
        >
          {{current}}
        </router-link-modified>
      </div>

      <!-- CURRENT  -->
      <div key="current"
           class="pagination__item  _current"
      >
        {{currentPage}}
      </div>

      <div class="pagination__col  _right">
        <router-link-modified v-for="current in pagesNext"
                     :key="current"
                     :to="{query: {...$route.query, page: current}}"
                     class="pagination__item"
        >
          {{current}}
        </router-link-modified>
        <div v-if="quantity > currentPage + 2" class="pagination__item  _dots">...</div>
        <router-link-modified v-if="currentPage < quantity"
                     :key="quantity"
                     :to="{query: {...$route.query, page: quantity}}"
                     class="pagination__item"
        >
          {{quantity}}
        </router-link-modified>
      </div>
      <!--    -->


      <!--  NEXT  -->
      <router-link-modified v-if="quantity > 1 && currentPage !== nextPage"
                   key="next"
                   :to="{query: {...$route.query, page: nextPage}}"
                   class="pagination__next">
        <BaseSvg name="ico-arrow-light"/>
      </router-link-modified>
      <div v-else
           key="next-disabled"
           class="pagination__next  _disabled"
      >
        <BaseSvg name="ico-arrow-light"/>
      </div>
    </div>

    <!--  ///////////////  -->

    <div v-if="withGoTo"
         class="pagination__go-to">
      <div class="pagination__go-to-title  d-md-none">{{$tGlobal('Page number')}}</div>
      <input v-model="input"
             type="number"
             @keypress.enter.prevent="onGoToClick"
             class="pagination__go-to-input  d-md-none">
      <input v-model="input"
             type="number"
             :placeholder="`${$tGlobal('Page number')} . . .`"
             @keypress.enter.prevent="onGoToClick"
             class="pagination__go-to-input  d-none  d-md-block">
      <button @click.prevent="onGoToClick"
              class="pagination__go-to-btn  base-btn  base-btn--blue-dark">
        <BaseSvg name="ico-arrow-light"/>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      quantity: {
        type: Number,
        default: 1
      },
      queryName: {
        type: String,
        default: 'page'
      },
      withGoTo: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        input: null
      }
    },
    computed: {
      currentPage() {
        return parseFloat(this.$route.query[this.queryName]) || 1
      },
      isCurrentPage() {
        return this.currentPage <= this.quantity
      },
      prevPage() {
        return this.currentPage > 1 ? this.currentPage - 1 : this.currentPage
      },
      nextPage() {
        return this.currentPage < this.quantity ? this.currentPage + 1 : this.currentPage
      },
      pagesPrev() {
        const count = this.isCurrentPage ? this.currentPage : this.quantity + 1
        if (count > 3) {
          return [count - 2, count - 1]
        }

        if (count > 2) {
          return [2]
        }

        return []
      },
      pagesPrevWithoutOne() {
        return this.pagesPrev[0] === 1 ? this.pagesPrev.slice(1) : this.pagesPrev
      },
      pagesNext() {
        if (this.quantity > this.currentPage + 2) {
          return [this.currentPage + 1, this.currentPage + 2]
        }

        if (this.quantity > this.currentPage + 1) {
          return [this.currentPage + 1]
        }

        return []
      },
      firstPageQuery() {
        const query = {...this.$route.query}
        delete query[this.queryName]
        return query
      },
      prevPageQuery() {
        if(this.prevPage === 1) {
          return this.firstPageQuery
        }

        return  {query: {...this.$route.query, page: this.prevPage}}
      }
    },
    methods: {
      onGoToClick() {
        let page = parseFloat(this.input) || 1
        if (page < 1) page = 1
        if (page > this.quantity) page = this.quantity
        this.input = null

        if (!page || this.currentPage === page) return

        this.$router.push({query: {...this.$route.query, [this.queryName]: page}})
      },
      checkRoute() {
        if (this.$route.query[this.queryName] === 1 || this.$route.query[this.queryName] === '1') {
          this.$router.replace({query: this.firstPageQuery})
        }
      }
    },
    watch: {
      '$route.query'(current, prev) {
        if (current[this.queryName] !== prev[this.queryName]) {
          this.checkRoute()
        }
      }
    },
    created() {
      this.checkRoute()
    }
  }
</script>

<style lang="less">

</style>
